/**
 * Created by AlexanderC on 6/16/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedisClusterException = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when redis cluster returned an error
 */
let RedisClusterException = exports.RedisClusterException = function (_Exception) {
  _inherits(RedisClusterException, _Exception);

  /**
   * @param {String} error
   */
  function RedisClusterException(error) {
    _classCallCheck(this, RedisClusterException);

    let originalException = error instanceof Error ? error : null;
    let errorPlain = originalException !== null ? originalException.message : error.toString();

    var _this = _possibleConstructorReturn(this, (RedisClusterException.__proto__ || Object.getPrototypeOf(RedisClusterException)).call(this, `Redis cluster operation failed: ${errorPlain}`));

    _this._originalException = originalException;
    return _this;
  }

  /**
   * @returns {Error}
   */


  _createClass(RedisClusterException, [{
    key: 'originalException',
    get: function get() {
      return this._originalException;
    }
  }]);

  return RedisClusterException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/Driver/Exception/RedisClusterException.js
// module id = 352
// module chunks = 0